import * as THREE from 'three'

import Debug from './Utils/Debug.js'
import Sizes from './Utils/Sizes.js'
import Time from './Utils/Time.js'
import Camera from './Camera.js'
import Renderer from './Renderer.js'
import World from './World/World.js'
import Resources from './Utils/Resources.js'
import Input from './Utils/Input.js'
import Selector from './Utils/Selector.js'
import UI from './Utils/UI.js';
import Progressor from './Utils/Progressor.js'

import sources from './sources.js'

let instance = null

export default class Experience
{
    constructor(_canvas, id)
    {
        // Singleton
        if(instance)
        {
            return instance
        }
        instance = this
        
        // Global access
        window.experience = this

        // Options
        this.canvas = _canvas

        // Setup
        this.curIndex = 0;
        this.tapType = -1;
        this.targetPos = new THREE.Vector3();
        this.screenType =0;
        this.loaded = false;
        this.state = id;

        if((window.innerWidth / window.innerHeight) < 1.3)
            this.screenType =  2;
        else if((window.innerWidth / window.innerHeight) < 1.45)
            this.screenType =  1;
        else
            this.screenType =  0;

        this.debug = new Debug()
        this.sizes = new Sizes()
        this.time = new Time()
        this.scene = new THREE.Scene()
        this.resources = new Resources(sources)
        this.input = new Input();
        this.world = new World()
        
        this.camera = new Camera()
        this.renderer = new Renderer()
        this.ui = new UI();
        
        this.selector = new Selector();
            
        this.progressor = new Progressor();
        
        //console.log((window.innerWidth / window.innerHeight))
        // Resize event
        this.sizes.on('resize', () =>
        {
            this.resize()
        })

        // Time tick event
        this.time.on('tick', () =>
        {
            this.update()
        })

        this.input.on('pointerDown', () =>
        {
            this.pointerDown()
        })
        this.input.on('pointerUp', () =>
        {
            this.pointerUp()
        })
        this.selector.on('poISelected', () =>
        {
            this.poISelected();
        })

        this.resources.on('onLoading',()=>
        {
            this.onLoading();
        })
        this.resources.on('ready',()=>
        {
            this.ready();
        })
        this.camera.on('onFirstInteraction',()=>
        {
            this.onFirstInteraction();
        })
        this.ui.on('leftCamera',()=>
        {
            this.leftCamera();
        })
        this.ui.on('rightCamera',()=>
        {
            this.rightCamera();
        })
        this.camera.on('onEndCameraMovement', ()=>
        {
            this.onEndCameraMovement();
        })
        this.camera.on('onEndIntro', ()=>
        {
            this.onEndIntro();
        })
        this.camera.on('onSegmentIntroEnded',()=>
        {
            this.onSegmentIntroEnded();
        }
        )
        this.ui.on('unloadArea',()=>
        {
            this.onUnloadArea();
        })
        this.ui.on('unloadSegment',()=>
        {
            this.onUnloadSegment();
        })
        this.input.on('gesture', ()=>
        {
            this.gesture();
        })
        this.camera.on('onStartDownAnimation',()=>
        {
            //console.log("toDown");
            this.onStartDownAnimation();
        })
        this.camera.on('quickEntry',()=>
        {
            this.quickEntry();
        }
        )
        this.progressor.on('onProgressorEnded', ()=>
        {
            this.onProgressorEnded();
        })
    }

    resize()
    {
        this.camera.resize()
        this.renderer.resize()
    }

    update()
    {
        this.camera.update()
        this.world.update()
        this.renderer.update()
        this.ui.update();
        this.selector.update()
    }

    pointerDown()
    {
        
    }
    pointerUp()
    {
        this.selector.pointerUp();
        
    }
    gesture()
    {
        //this.camera.EvaluateDrag();
    }
    onSegmentIntroEnded()
    {
        this.ui.segmentIntroEnded();
    }
    onStartDownAnimation()
    {
        this.ui.onStartDownAnimation();
    }
    poISelected()
    {
        this.camera.poISelected();
        this.ui.poISelected();
    }
    quickEntry()
    {
        this.ui.quickEntry();
    }
    onLoading()
    {
        this.ui.onLoading();
    }

    ready()
    {
        this.loaded = true;        
        this.progressor.onLoaded();
        this.ui.onLoaded();
    }
    onEndIntro()
    {
        this.ui.onEndIntro();
    }
    onProgressorEnded()
    {
        this.ui.progressorEnded();
        this.camera.progressorEnded();
    }

    destroy()
    {
        //this.sizes.off('resize')
        //this.time.off('tick')
        
        // Traverse the whole scene
        this.scene.traverse((child) =>
        {
            // Test if it's a mesh
            if(child instanceof THREE.Mesh)
            {
                child.geometry.dispose()

                // Loop through the material properties
                for(const key in child.material)
                {
                    const value = child.material[key]

                    // Test if there is a dispose function
                    if(value && typeof value.dispose === 'function')
                    {
                        value.dispose()
                    }
                }
            }
        })
        this.world.destroy();

        this.camera.controls.dispose()
        this.renderer.instance.dispose()
        this.renderer.instance.renderLists.dispose();
        if(this.debug.active)
            this.debug.ui.destroy()
    }
    onFirstInteraction()
    {
        this.ui.onFirstInteraction();
    }
    leftCamera()
    {
        this.camera.leftCamera();
    }
    rightCamera()
    {
        this.camera.rightCamera();
    }
    onEndCameraMovement()
    {
        this.ui.updateSegments();
    }
    onUnloadArea()
    {
        this.ui.swapToSegmentStart();          
        this.progressor.onToSegment();
        this.camera.resetToSegment();
    }
    onUnloadSegment()
    {
        this.ui.swapToIslandStart();        
        this.progressor.onToIsland();
        this.camera.resetToIsland();
    }
}